import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = {
  position: "relative",
  height: { xs: "46px", sm: "60px", md: "60px" },
  mx: { xs: "12px", sm: "50px", md: "50px" },
  mb: { xs: "8px", sm: "17px", md: "17px" },
  marginBottom: { xs: "15px", sm: "15px", md: "15px" },
  "@media (orientation: landscape) and (max-width: 960px)": {
    height: "40px",
    mb: "5px",
    marginBottom: "10px",
  },
  "& .markdown": {
    fontSize: { xs: "13px", sm: "14px", md: "14px" },
    lineHeight: { xs: 1.25, sm: 1.35, md: 1.5 },
  },
  "& .markdown p": {
    fontSize: "inherit",
    lineHeight: "inherit",
  },
};

export const textStyle: SxProps<Theme> = (theme) => ({
  mt: "-5px",
  fontWeight: 500,
  fontSize: { xs: "13px", sm: "14px", md: "14px" },
  lineHeight: { xs: 1.25, sm: 1.35, md: 1.5 },
  textAlign: "center",
  color: theme.palette.leaderBoardBlock?.textColor,
});

export const lineStyle: SxProps<Theme> = {
  position: "absolute",
  top: {
    xs: "116%",
    sm: "86%",
    md: "86%",
  },
  left: 0,
  right: { xs: -15, sm: -25, md: -25 },
  height: "4px",
  background: "#06B6D480",
  zIndex: 0,
  "&::after": {
    content: '""',
    position: "absolute",
    right: { xs: -5, sm: -10, md: -10 },
    top: "52%",
    transform: "translateY(-50%)",
    width: 0,
    height: 0,
    borderTop: "10px solid transparent",
    borderBottom: "10px solid transparent",
    borderLeft: "14px solid #06B6D4",
  },
};

export const getAvatarWrapperStyle = (
  offsetPercent: number,
  shiftPx: number
): SxProps<Theme> => ({
  position: "absolute",
  top: { xs: "105%", sm: "75%", md: "75%" },
  left: `${offsetPercent}%`,
  transform: `translate(calc(-50% + ${shiftPx}px), -50%)`,
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const getPlaceTextStyle = (isCurrentUser: boolean): SxProps<Theme> => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  maxWidth: "100px",
  fontSize: isCurrentUser ? "0.8rem" : "0.7rem",
  color: isCurrentUser ? "transparent" : "transparent",
});

export const getAvatarStyle = (
  isCurrentUser: boolean,
  isMobile: boolean = false
): SxProps<Theme> => ({
  "& .MuiAvatar-root": {
    fontSize: isMobile ? "7px !important" : "14px !important",
    "& .MuiSvgIcon-root": {
      fontSize: isMobile ? "7px !important" : "14px !important",
    },
  },
  fontSize: isMobile ? "7px !important" : "14px !important",
});
